const DEMO_STATS = {
  unique_visitors: 1280,
  total_visits: 3420,
  total_likes: 184,
  site_likes: 96,
  visitors_timeseries: [
    { date: "2026-06-21", visitors: 140, page_views: 220 },
    { date: "2026-06-22", visitors: 182, page_views: 280 },
    { date: "2026-06-23", visitors: 165, page_views: 250 },
    { date: "2026-06-24", visitors: 210, page_views: 320 },
    { date: "2026-06-25", visitors: 195, page_views: 290 },
    { date: "2026-06-26", visitors: 230, page_views: 360 },
    { date: "2026-06-27", visitors: 258, page_views: 400 },
  ],
  likes_per_product: [
    { slug: "base", name: "Base Family", likes: 74 },
    { slug: "introductory", name: "Introductory", likes: 41 },
    { slug: "hospicash", name: "HospiCash", likes: 34 },
    { slug: "personal-accident", name: "Personal Accident", likes: 22 },
    { slug: "cyber-shield", name: "Cyber Shield", likes: 13 },
  ],
  recent_visits: [
    { visitor_id: "v_demo_01", path: "/", created_at: "2026-06-27T10:20:00Z" },
    { visitor_id: "v_demo_02", path: "/plans", created_at: "2026-06-27T09:50:00Z" },
  ],
};

export const api = {
  get: async (url) => {
    if (url === "/admin/stats") {
      return { data: DEMO_STATS };
    }
    if (url.startsWith("/likes/summary")) {
      return { data: { counts: { site: 96, base: 74, introductory: 41, hospicash: 34, "personal-accident": 22, "cyber-shield": 13 } } };
    }
    if (url.startsWith("/likes/me")) {
      return { data: { liked: [] } };
    }
    if (url.startsWith("/auth/me")) {
      const token = localStorage.getItem("hb_token");
      if (!token?.startsWith("hb_admin_session_")) {
        throw { response: { data: { detail: "Not authenticated" } } };
      }
      return { data: { id: "demo-admin", email: "admin@happibandhu.in", name: "Demo Admin" } };
    }
    return { data: {} };
  },
  post: async (url, body) => {
    if (url === "/likes") {
      const liked = body.target === "site" ? true : false;
      return { data: { target: body.target, liked, count: 100 + Math.floor(Math.random() * 20) } };
    }
    if (url === "/auth/login") {
      if (body.email !== "admin@happibandhu.in" || body.password !== "HappiAdmin@2026") {
        throw { response: { data: { detail: "Invalid credentials" } } };
      }
      return {
        data: {
          token: `hb_admin_session_${Date.now().toString(36)}`,
          user: { id: "demo-admin", email: body.email, name: "Demo Admin" },
        },
      };
    }
    if (url === "/visits") {
      return { data: { ok: true } };
    }
    return { data: {} };
  },
};

export function getVisitorId() {
  let id = localStorage.getItem("hb_visitor_id");
  if (!id) {
    id = `v_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem("hb_visitor_id", id);
  }
  return id;
}
